import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const GraphWrapper = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  z-index: 0;
`

export const TextOverlay = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  align-items: center;
  justify-content: center;
  z-index: -1;

  p.display-value {
    font-size: ${theme.typography.sizes.xm};
  }
`

export const GraphOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 150px;
`
